<template>
  <div class="container myZJ" style="padding: 0;margin: 0;">
    <div
      style="width: calc(100% - 432px);background: #ffffff;border-radius: 0 8px 8px 8px;height: 100%;margin-right: 16px;padding: 0px;"
    >
      <!-- <div v-if="tabSwitchListData.length > 1" style="margin-bottom: 16px;">
        <dy-subTab
          :options="tabSwitchListData"
          @input="changeTableRadio"
          :value="tableRadio"
        ></dy-subTab>
      </div> -->

      <div v-if="!eduitApp">
        <div class="titleBody">
          <div class="titleText">
            <div class="titleicon"></div>
            <span class="titlecontent">入会下载明星壁纸活动配置</span>
          </div>
        </div>
        <div style="display: flex; margin: 20px 0;flex-direction: column;">
          <p style="margin: 20px">
            请用手机京东扫描下面二维码查看您店铺的活动详情
          </p>
          <qrcode-vue
            v-if="qrcodeVue.value"
            class="qrcode"
            :id="'qrcode'"
            :ref="'qrcode'"
            :size="qrcodeVue.size"
            :value="qrcodeVue.value"
            :bgColor="qrcodeVue.bgColor"
            :fgColor="qrcodeVue.fgColor"
            style="margin-left: 20px;"
          ></qrcode-vue>
          <div>
            <p style="margin: 20px">
              链接地址：(手机京东店铺中活动详情链接地址)
            </p>
            <el-input
              v-model="qrcodeVue.value"
              style="margin: 0 20px; width: 220px"
            ></el-input
            ><el-button
              type="primary"
              v-clipboard:copy="qrcodeVue.value"
              v-clipboard:success="onCopy"
              v-clipboard:error="onError"
              >复制</el-button
            >
            <el-button type="primary" @click="handleSrcImg()">下载</el-button>
          </div>
        </div>

        <div>
          <el-button
            style="width: auto;"
            type="primary"
            @click="eduitApp = true"
            >活动配置</el-button
          >
        </div>
      </div>

      <div v-else v-loading="isLoading">
        <div class="titleBody">
          <div class="titleText">
            <div class="titleicon"></div>
            <span class="titlecontent">入会下载明星壁纸活动配置</span>
          </div>
        </div>
        <div class="frombody">
          <div class="fromitem">
            <div class="fromtitle">
              手机壁纸：
            </div>
            <el-upload
              action="#"
              ref="upload"
              :on-change="
                (file, fileList) => {
                  imageLabelsChange(file, fileList, 'phone');
                }
              "
              :show-file-list="false"
              accept=".png, .jpg, .gif"
              :auto-upload="false"
              
            >
              <el-button plain style="margin-right: 16px;">上传图片</el-button>
            </el-upload>
            <div
              style="display: flex;align-items: center;font-weight: 400;font-size: 12px;color: #999999"
            >
              尺寸建议：4500px*9688px；支持格式：jpg，png，gif
            </div>
          </div>
          <div style="display: flex;margin: 0 0 10px 62px;">
            <draggable
              v-model="phoneList"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="padding: 10px;"
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in phoneList"
                  :key="item.compressedImageUrl"
                  style="display: inline-block; position: relative"
                  class="upload-item"
                >
                  <el-image
                    :src="item.compressedImageUrl"
                    class="phone-img"
                    style="display: inline-block"
                    fit="cover"
                    :lazy="true"
                  />&nbsp;
                  <div class="delectPosible phone-img">
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="@/assets/thdImg/pages/delet.svg"
                      @click.stop="delec(index, 'phoneList')"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </div>
          <div class="fromitem">
            <div class="fromtitle">
              电脑壁纸：
            </div>
            <el-upload
              action="#"
              ref="upload"
              :on-change="
                (file, fileList) => {
                  imageLabelsChange(file, fileList, 'computer');
                }
              "
              :show-file-list="false"
              accept=".png, .jpg, .gif"
              :auto-upload="false"
              
            >
              <el-button plain style="margin-right: 16px;">上传图片</el-button>
            </el-upload>
            <div
              style="display: flex;align-items: center;font-weight: 400;font-size: 12px;color: #999999"
            >
              尺寸建议：5567px*3125px；支持格式：jpg，png，gif
            </div>
          </div>
          <div style="display: flex;margin: 0 0 10px 62px;">
            <draggable
              v-model="computerList"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="padding: 10px;"
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in computerList"
                  :key="item.compressedImageUrl"
                  style="display: inline-block; position: relative"
                  class="upload-item"
                >
                  <el-image
                    :src="item.compressedImageUrl"
                    class="computer-img"
                    style="display: inline-block"
                    fit="cover"
                    :lazy="true"
                  />&nbsp;
                  <div class="delectPosible computer-img">
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="@/assets/thdImg/pages/delet.svg"
                      @click.stop="delec(index, 'computerList')"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </div>
          <div class="fromitem">
            <div class="fromtitle">
              ipad壁纸：
            </div>
            <el-upload
              action="#"
              ref="upload"
              :on-change="
                (file, fileList) => {
                  imageLabelsChange(file, fileList, 'ipad');
                }
              "
              :show-file-list="false"
              accept=".png, .jpg, .gif"
              :auto-upload="false"
              
            >
              <el-button plain style="margin-right: 16px;">上传图片</el-button>
            </el-upload>
            <div
              style="display: flex;align-items: center;font-weight: 400;font-size: 12px;color: #999999"
            >
              尺寸建议：4000px*2795px；支持格式：jpg，png，gif
            </div>
          </div>
          <div style="display: flex;margin: 0 0 10px 62px;">
            <draggable
              v-model="ipadList"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="padding: 10px;"
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in ipadList"
                  :key="item.compressedImageUrl"
                  style="display: inline-block; position: relative"
                  class="upload-item"
                >
                  <el-image
                    :src="item.compressedImageUrl"
                    class="ipad-img"
                    style="display: inline-block"
                    fit="cover"
                    :lazy="true"
                  />&nbsp;
                  <div class="delectPosible ipad-img">
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="@/assets/thdImg/pages/delet.svg"
                      @click.stop="delec(index, 'ipadList')"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </div>
        </div>

        <div>
          <el-button style="width: auto;" type="primary" @click="saveWinnerApp"
            >保存设置</el-button
          >
          <el-button style="width: auto;" @click="resetLists">清空</el-button>
        </div>
      </div>
    </div>

    <div
      style="width: 416px;background: #ffffff;border-radius: 8px;height: 100%;padding: 0px;overflow-y: auto;"
    >
      <div class="titleBody">
        <div class="titleText">
          <div class="titleicon"></div>
          <span class="titlecontent">页面效果预览</span>
        </div>
      </div>
      <div
        style="width: 100%;display: flex;justify-content: center;margin-top: 20px;position: relative;"
      >
        <phoneShow
          :winnerList="winnerList"
          :formConfig="formConfig"
          :pictureList="pictureList"
        ></phoneShow>
        <div
          v-if="pictureList.length > 0"
          style="position: absolute;right: 24px;top:500px;height: 60px;width: 60px;"
        >
          <img
            src="@/assets/images/starWallpapers/download.png"
            style="width: 100%;"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import qrcodeVue from "qrcode-vue";
import phoneShow from "./phoneShow.vue";
import { mapState } from "vuex";
import draggable from "vuedraggable";
import { uploadFileNew, configSave, configDetail } from "@/api/deeyeo.js";
export default {
  components: {
    qrcodeVue,
    phoneShow,
    draggable,
  },
  data() {
    return {
      newAppId: "",
      pageUrl: "",
      // 限制图片上传格式
      extensions: [".jpg", ".png", ".gif"],
      SellerList: [],
      winnerList: [],
      tabSwitchListData: [],
      eduitApp: true,
      tableRadio: "",
      recordData: {
        // 分页
        current: 1,
        size: 100,
      },
      qrcodeVue: {
        size: 200,
        bgColor: "#fff",
        fgColor: "#000",
        value: "", //二维码地址
        logo: require("@/assets/thdImg/common/jd_logo.svg"), //logo图片
      },
      CacheformConfig: {
        title: "中奖名单查询",
        successText: "查到以下中奖记录",
        failText: "很遗憾，你未中奖",
        backgroundImage: "",
        textColor: "#B46E1D",
        buttonBGColor: "#000000",
        buttonTXColor: "#ffffff",
        isShowIcon: "0",
      },
      formConfig: {
        title: "中奖名单查询",
        id: "",
      },
      pageform: {
        templateScene: "5",
        miniappAutoId: "",
        current: 1,
        size: 10,
      },
      appId: "",

      draggingId: [], //有拖拽时要传的ID顺序
      // mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //

      phoneList: [],
      ipadList: [],
      computerList: [],
      isLoading: false,
    };
  },
  computed: {
    ...mapState(["loginUserInfo"]),
    pictureList() {
      let newArr = [];
      this.phoneList.forEach((item) => {
        newArr.push(item);
      });
      this.computerList.forEach((item) => {
        newArr.push(item);
      });
      this.ipadList.forEach((item) => {
        newArr.push(item);
      });
      // console.log("newArr", newArr);
      return newArr;
    },
  },
  created() {},
  mounted() {
    // this.init();
  },
  methods: {
    //图片拖拽
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      // console.log("this.mainImagelist)", this.mainImagelist);
      // this.mainImagelist.forEach((item) => {
      //   // arr.push(item.wareId);
      //   arr.push(item.skuId);
      //   this.draggingId = arr;
      // });
      // console.log("this.mainImagelist)", arr);
    },
    resetLists() {
      this.phoneList = [];
      this.ipadList = [];
      this.computerList = [];
    },
    async saveWinnerApp() {
      let imgList = [...this.phoneList, ...this.computerList, ...this.ipadList];
      let formData = {
        // componentJson: JSON.stringify(this.formConfig),
        detailInfo: JSON.stringify(imgList),
        // templateName: this.formConfig.title,
        id: this.tableRadio,
        // templateScene: "5",
      };
      if (this.appId) {
        formData.id = this.appId;
      }
      let res = await configSave(formData);
      if (res.code == 1) {
        this.queryTemplate();
        this.$message.success("保存成功");
      } else {
        this.$message.error(res.message);
      }
    },
    init() {
      this.queryTemplate();
    },
    async getQRurl(type) {
      let xcxUrl = this.$commonUrl();
      // let params1 = `%7B%22venderId%22%3A%22${Number(this.formConfig.venderId)}%22%7D`
      // let params1 = `%7B%22venderId%22%3A%22${Number(this.formConfig.venderId)}%22%2C%22%7D`;
      // let params1 = `%7B%22venderId%22%3A%22${ this.formConfig.venderId}%7D`
      // this.qrcodeVue.value = xcxUrl + "pages/starWallpapers/starWallpapers.html%3fitem%3d" + params1;
      // this.qrcodeVue.value = xcxUrl + `pages/starWallpapers/starWallpapers.html%3fvenderId%22%3A%22${this.formConfig.venderId}`;
      let options = {
        activityId: "",
        venderId: this.formConfig.venderId,
      };
      let params1 = `%7B%22activityId%22%3A%22${options.activityId}%22%2C%22venderId%22%3A%22${options.venderId}%22%7D`;
      this.qrcodeVue.value =
        xcxUrl + "pages/starWallpapers/starWallpapers.html%3fitem%3d" + params1;
    },
    async queryTemplate() {
      this.pageform.miniappAutoId = this.tableRadio;
      let res = await configDetail();
      console.log("res", res);
      // return
      if (res.code == 1) {
        if (res.data) {
          this.appId = res.data.id;
          // this.pageUrl = `pages/starWallpapers/starWallpapers?shopId=${this.loginUserInfo.shopId}&appId=${this.newAppId}&templateId=${this.appId}&templateScene=5`;
          this.tableRadio = res.data.id;
          let imgList = JSON.parse(res.data.detailInfo);
          this.formConfig = res.data;
          console.log("this.formConfig", this.formConfig);
          let phoneList = [];
          let ipadList = [];
          let computerList = [];
          imgList.forEach((item) => {
            if (item.type == "phone") {
              phoneList.push(item);
            } else if (item.type == "ipad") {
              ipadList.push(item);
            } else if (item.type == "computer") {
              computerList.push(item);
            }
          });
          this.phoneList = phoneList;
          this.ipadList = ipadList;
          this.computerList = computerList;

          this.eduitApp = false;
          this.getQRurl();
        } else {
          this.qrcodeVue.value = "";
          this.appId = "";
          this.formConfig = {};
          this.eduitApp = true;
        }
      }
    },
    imageLabelsChange(file, fileList, type) {
      let fileExtensions = this.extensions.some((ext) =>
        file.name.toLowerCase().endsWith(ext)
      );
      if (!fileExtensions) {
        this.$message.error("图片格式错误");
        this.$refs.upload.clearFiles();
        return;
      }
      this.$refs.upload.clearFiles();
      let formdata = new FormData();
      formdata.append("file", file.raw);
      this.isLoading = true;
      uploadFileNew(formdata, 4)
        .then((res) => {
          // 获取图片真实url
          if (res.code == 1) {
            // this.formConfig.backgroundImage = res.data;
            // this.mainImagelist.push(res.data.fileUrl);
            if (type == "phone") {
              this.phoneList.push({ ...res.data, type: "phone" });
            } else if (type == "ipad") {
              this.ipadList.push({ ...res.data, type: "ipad" });
            } else if (type == "computer") {
              this.computerList.push({ ...res.data, type: "computer" });
            }
          } else {
            this.$message.error(res.message);
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    goList() {
      this.$emit("goList", "list");
    },
    openUrl() {
      window.open(
        "https://bytedance.feishu.cn/docx/doxcnFfNSM0WOaii8JHnWtZIqle?from=from_copylink",
        "_blank"
      );
    },
    onCopy() {
      this.$message.success("复制成功");
    },
    onError() {
      this.$message.error("复制失败");
    },

    changeTableRadio(val) {
      this.tableRadio = val;
      this.queryTemplate();
      this.eduitApp = true;
      console.log(val);
    },
    handleSrcImg() {
      // 获取要下载的图片
      let img = document.querySelector(`#qrcode img`);
      // 获取图片地址
      let url = img.src;
      // 创建一个a节点插入的document
      let a = document.createElement("a");
      // 模拟鼠标click点击事件
      let event = new MouseEvent("click");
      // 设置a节点的download属性值
      a.download = "imgQR";
      // 将图片的src赋值给a节点的href
      a.href = url;
      // 触发鼠标点击事件
      a.dispatchEvent(event);
    },
    delec(index, list) {
      this[list].splice(index, 1);
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  display: flex;
  flex-wrap: nowrap;
  height: calc(100vh - 140px);
  font-family: PingFang SC, PingFang SC;
  .frombody {
    padding: 20px 10px 10px 10px;
    background: #fff;
    .fromitem {
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .fromtitle {
        font-weight: 400;
        font-size: 14px;
        color: #666666;
        display: flex;
        justify-content: end;
        // width: 120px;
      }
      .prompt {
        margin-left: 10px;
        font-size: 12px;
        color: #cccccc;
      }
    }
  }

  .titleBody {
    width: 100%;
    height: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .titleText {
      display: flex;
      align-items: center;

      .titleicon {
        width: 2px;
        background: #2768ff;
        margin-right: 8px;
        height: 12px;
      }

      .titlecontent {
        font-family: PingFang SC, PingFang SC;
        font-weight: bold;
        font-size: 14px;
        color: #1f1f1f;
        line-height: 16px;
        text-align: left;
        font-style: normal;
        text-transform: none;
      }
    }
  }
}
.upload-img {
  background: #ffffff;
  border-radius: 2px 2px 2px 2px;
  border: 1px dotted #dcdfe6;
  display: flex;
  justify-content: center;
  align-items: center;
}
.phone-img {
  width: 58px;
  height: 125px;
}
.computer-img {
  width: 118px;
  height: 66px;
}
.ipad-img {
  width: 112px;
  height: 78px;
}
.upload-item {
  margin-right: 10px;
  &:hover .delectPosible {
    display: block;
  }

  .delectPosible {
    display: none;
    position: absolute;
    top: 0px;
    // right: 6px;
    background: rgba(0, 0, 0, 0.7);
    cursor: pointer;
    .delectIcom {
      width: 24px;
      height: 24px;
      position: absolute;
      top: -9px;
      right: -8px;
    }
    .delectSort {
      position: absolute;
      top: 50%;
      color: #fff;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
</style>
<style lang="scss">
.fromitem {
  .el-input__inner {
    border-radius: 2px;
  }
}
</style>
